import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'teamSelectionType',
    standalone: false
})
export class teamSelectionTypePipe implements PipeTransform {

  transform(value: any): any {
    if(value === 1) {
      return 'Avtal';
    }
    if(value === 2) {
        return 'Anläggning';
    }
    if(value === 3) {
        return 'Kostnadsställe';
    }
    if(value === 4) {
      return 'Kund';
    }
  }

}